export default __webpack_public_path__ + "e8f39fac4e2253d67e9408e35ca038ba.ttf";